module.exports = __webpack_public_path__ + "static/media/paper22.c6c8efa3.jpg";